/**
 * Constants for PendingActions feature
 */

// Action types for the pending actions (UI identifiers)
export const ACTION_TYPES = {
  M3P_ELIGIBLE: "m3p_eligible",
  EXPRESS_ENROLL_INVITES_ELIGIBLE: "express_enroll_invites_eligible",
  NEW_PROGRAMS: "new_programs",
  PENDING_RENEWALS: "pending_renewals",
  OVERDUE_TASKS: "overdue_tasks"
};

// API action types (used for backend communication and auto-approval)
export const API_ACTION_TYPES = {
  PAYTIENT: "paytient",
  EXPRESS_ENROLL_INVITES: "express_enroll_invites"
};

// Source identifiers for tracking where actions originate
export const SEND_SOURCES = {
  BULK_SEND: "bulk_send"
};
